// echarts.ts
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, PieChart, HeatmapChart, CustomChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  VisualMapComponent,
  DataZoomComponent,
} from "echarts/components";

use([
  CanvasRenderer,
  BarChart,
  PieChart,
  HeatmapChart,
  CustomChart, // ← needed for the Gantt/timeline bars
  GridComponent,
  TooltipComponent,
  LegendComponent,
  VisualMapComponent,
  DataZoomComponent, // ← optional, lets users scroll/zoom a long timeline
]);
